module.exports = __webpack_public_path__ + "static/media/curator.913053fa.png";